import { EyeIcon } from "@heroicons/react/24/outline";
import { cadenceLabel, stepIcon, timingLabel } from "./actionSteps";

const SEND_STEP_TYPE = "payment.request.send";

// A single row in an Action card's step timeline: icon tile, timing chip, and
// description — with a dotted connector to the next row unless it's the last. When
// `onPreviewStep` is supplied, a payment send row also offers a read-only preview of
// the request email/SMS that step will deliver.
export default function ActionStepRow({ group, isLast, onPreviewStep, instalment }) {
  const { Icon, className } = stepIcon(group.stepType);
  const cadence = group.steps.length > 1 ? cadenceLabel(group) : null;
  // Only a send step that actually carries its payload can be previewed — suggestion steps always
  // do; activity-feed steps only once the action detail has loaded it.
  const previewStep =
    onPreviewStep && group.stepType === SEND_STEP_TYPE && group.steps[0]?.payload
      ? group.steps[0]
      : null;

  return (
    <div className="relative flex gap-3 pb-4 last:pb-0">
      {!isLast && (
        <span className="absolute left-[15px] top-8 h-[calc(100%-1rem)] w-px border-l border-dashed border-zinc-300" />
      )}
      <span
        className={`flex size-8 shrink-0 items-center justify-center rounded-full ${className}`}
      >
        <Icon aria-hidden="true" className="size-4" />
      </span>
      <div className="min-w-0 flex-1 pt-0.5">
        <div className="text-xs text-zinc-400">{timingLabel(group)}</div>
        <div className="text-sm text-zinc-900">
          {group.description}
          {cadence && <span className="text-zinc-500"> · {cadence}</span>}
        </div>
      </div>
      {previewStep && (
        <button
          type="button"
          onClick={() => onPreviewStep(previewStep, instalment)}
          className="mt-0.5 flex shrink-0 items-center gap-1 self-start text-xs font-medium text-zinc-400 hover:text-zinc-600"
        >
          <EyeIcon aria-hidden="true" className="size-3.5" />
          Preview
        </button>
      )}
    </div>
  );
}
